import { render, staticRenderFns } from "./AllSettings.vue?vue&type=template&id=8b391238&scoped=true"
import script from "./AllSettings.vue?vue&type=script&lang=js"
export * from "./AllSettings.vue?vue&type=script&lang=js"
import style0 from "./AllSettings.vue?vue&type=style&index=0&id=8b391238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b391238",
  null
  
)

export default component.exports